import PopoverMixin from './popoverMixins.js'
  export default {
    mixins: [PopoverMixin],
    props: {
      trigger: {
        type: String,
        default: 'hover'
      },
      effect: {
        type: String,
        default: 'scale'
      }
    }
  }


/** WEBPACK FOOTER **
 ** ./src/Tooltip.vue
 **/